import React from 'react';
import { useEffect, useState } from 'react';

const CleverTapScript = React.memo(({ limit = 10, onLoad }: { limit?: number; onLoad?: () => void }) => {
	const [isClient, setIsClient] = useState(false);
	const randomPercentage = React.useMemo(() => Math.floor(Math.random() * 100), []);

	useEffect(() => {
		// Original CleverTap initialization
		(window as any).CLEVERTAP_ACCOUNT_ID = process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID;
		setIsClient(true);

		if (isClient && randomPercentage <= limit) {
			// Create and append the initialization script
			const initScript = document.createElement('script');
			initScript.type = 'text/javascript';
			initScript.innerHTML = `
				var clevertap = {event:[], profile:[], account:[], onUserLogin:[], notifications:[], privacy:[]};
				clevertap.account.push({"id": "${(window as any).CLEVERTAP_ACCOUNT_ID}"});
				clevertap.privacy.push({optOut: false});
				clevertap.privacy.push({useIP: false});
			`;
			document.head.appendChild(initScript);

			// Create and append the main CleverTap script
			const mainScript = document.createElement('script');
			mainScript.type = 'text/javascript';
			mainScript.async = true;
			mainScript.src = ('https:' === document.location.protocol ? 
				'https://d2r1yp2w7bby2u.cloudfront.net' : 
				'http://static.clevertap.com') + '/js/clevertap.min.js';
			
			mainScript.onload = () => {
				if (onLoad) {
					onLoad();
				}
				console.log('CleverTap script loaded successfully');
			};

			document.head.appendChild(mainScript);
		}

		// Cleanup function
		return () => {
			if (onLoad) {
				delete (window as any).onCleverTapLoad;
			}
		};
	}, [isClient, randomPercentage, limit, onLoad]);

	return null;
});

export default CleverTapScript;
